import * as Types from '../mutation-types'
import { set_many, set_one, ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST } from '../mutation-mixins'

export default {

    ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST,

    [Types.SET_MANY]: set_many({ to: 'entities' }),
    [Types.SET_ONE]: set_one({ to: 'entities' }),

}
